import React, { useState, useCallback, useRef } from 'react';
import styled from 'styled-components';

const TouchSurfaceWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: none;
  touch-action: none; /* 防止浏览器默认行为 */
  
  @media (max-width: 768px) {
    display: block;
  }
`;

// 定义滑动方向的阈值（像素）
const SWIPE_THRESHOLD = 50;
// 点击阈值时间（毫秒）
const TAP_THRESHOLD = 200;

const TouchController = ({ onMove, onRotate, onHardDrop }) => {
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [startTime, setStartTime] = useState(0);
  const touchSurfaceRef = useRef(null);
  
  // 处理触摸开始
  const handleTouchStart = useCallback((e) => {
    const touch = e.touches[0];
    setStartPos({ x: touch.clientX, y: touch.clientY });
    setStartTime(Date.now());
  }, []);
  
  // 处理触摸结束
  const handleTouchEnd = useCallback((e) => {
    if (e.changedTouches.length === 0) return;
    
    const touch = e.changedTouches[0];
    const deltaX = touch.clientX - startPos.x;
    const deltaY = touch.clientY - startPos.y;
    const touchDuration = Date.now() - startTime;
    
    // 检测是快速点击 - 作为旋转操作
    if (Math.abs(deltaX) < 20 && Math.abs(deltaY) < 20 && touchDuration < TAP_THRESHOLD) {
      onRotate();
      return;
    }
    
    // 水平滑动距离大于垂直滑动
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
        // 左右滑动
        if (deltaX > 0) {
          onMove(1, 0); // 右移
        } else {
          onMove(-1, 0); // 左移
        }
      }
    } else {
      if (deltaY > SWIPE_THRESHOLD) {
        // 向下滑动 - 加速下落
        onMove(0, 1);
      } else if (deltaY < -SWIPE_THRESHOLD) {
        // 向上滑动 - 硬降
        onHardDrop();
      }
    }
  }, [startPos, startTime, onMove, onRotate, onHardDrop]);
  
  return (
    <TouchSurfaceWrapper
      ref={touchSurfaceRef}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    />
  );
};

export default TouchController;